import { Application } from '@hotwired/stimulus'
import { configure } from 'nunjucks'
import format from 'number-format.js'
import dayjs from 'dayjs'

import './src/pages/compiled'
import './src/components/compiled'

import { registerControllers } from 'stimulus-vite-helpers'

import './src/pwa'

import { router } from './src/router'

import './src/css/icons.scss'
import './src/css/awn.scss'
import './src/css/styles.scss'

const nunjucksEnv = configure({
    throwOnUndefined: true
})

nunjucksEnv.addFilter('money', (value) => format('$#,##0.00', value))

nunjucksEnv.addFilter('numeric', (value) => format('#,##0.##', value))

nunjucksEnv.addFilter('btoa', (value) => btoa(value))

nunjucksEnv.addFilter('datetime', (value) => dayjs(value,
    'YYYY-MM-DD HH:mm:ss.SSS').format('DD/MM/YYYY HH:mm:ss'))

nunjucksEnv.addFilter('date', (value) => dayjs(value,
    'YYYY-MM-DD').format('DD/MM/YYYY'))

const application = Application.start()

const controllers = import.meta.glob('./src/controllers/*_controller.js', {
    eager: true
})

router.resolve()

registerControllers(application, controllers)
